import AOS from 'aos';
import ModuloBox from './plugins/modulobox.js';
import './plugins/gridzy.min.js';
import CookieNotification from "bb-cookie-notification";
import Axios from 'axios';
import Flickity from 'flickity';
import Mixitup from 'mixitup';
import axios from 'axios';
import {
    Carousel,
    Dropdown,
    Collapse,
    Embed
} from 'bootstrap';
import {
    Loader
} from '@googlemaps/js-api-loader'

// Init Animate On Scroll
AOS.init();

document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

const submitForm = (gRecaptchaResponse) => {
    const form = document.getElementById('form');

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', gRecaptchaResponse);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('hidden');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if (!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(window.location.href, formData).then((response) => {
        if (response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            form.innerHTML = '';
        }
    }).catch((exception) => {
        grecaptcha.reset();
        if (exception.response.data.errors) {
            for (let error in exception.response.data.errors) {
                const el = form.querySelector('[name="' + error + '"]');
                el.classList.add('is-invalid');
                if (el.parentNode.querySelector('.d-none') !== null) {
                    el.parentNode.querySelector('.d-none').classList.remove('d-none');
                }
            }
        }
    });
}

window.submitForm = submitForm;

const mapElement = document.getElementById('map');
if (mapElement) {
    // Google Maps
    const loader = new Loader({
        apiKey: "AIzaSyBL7rhbJyG1YZvxj5MlVP4aGur4iXMihjg",
        version: "weekly"
    });
    loader.load().then(() => {
        const distilleries = JSON.parse(mapElement.dataset.distilleries);

        if (distilleries.length > 0) {

            // Initialize map, set geographic center of Scotland as center of the map.
            const map = new google.maps.Map(mapElement, {
                center: {
                    lat: 56.818130,
                    lng: -4.234320
                },
                zoom: 7,
            });

            const bounds = new google.maps.LatLngBounds();

            let activeWindow;

            // Add pins to the map, extend the bounds.
            distilleries.map((distillery) => {
                if(distillery.latitude !== null && distillery.longitude !== null) {
                    const latLng = {
                        lat: parseFloat(distillery.latitude),
                        lng: parseFloat(distillery.longitude)
                    };
                    const icon   = {
                        url:        "/img/destilleerderij.svg", // url
                        scaledSize: new google.maps.Size(30, 30), // scaled size
                        origin:     new google.maps.Point(0, 0), // origin
                        anchor:     new google.maps.Point(0, 0) // anchor
                    };
                    const marker = new google.maps.Marker({
                        position: latLng,
                        map:      map,
                        icon:     icon
                    });

                    let innerHtml = '';
                    if(distillery.items.length > 0) {
                        distillery.items.map((item) => {
                            innerHtml += '' +
                                '<a class="block-overview block-overview-small" href="' + item.url + '">\n' +
                                '    <div class="w-100 box-shadow img-cover block-image overlay-gradient-bottom"\n' +
                                '         style="background-image: url(' + item.image + ')">\n' +
                                '        <div class="block-label p-4">\n' +
                                '            <span class="block-type ' + item.labelClass + '">' + item.label + '</span>\n' +
                                '            <span class="block-title">' + item.title + '</span>\n' +
                                '        </div>\n' +
                                '    </div>\n' +
                                '</a>';
                        });
                    }

                    const html =
                              '<div class="distillery-content">' +
                              '<div class="distillery-image">' + ((distillery.images.length > 0) ? '<img src="' + distillery.images[0].resizeable + '?w=500" class="img-fluid" />' : '') + '</div>' +
                              '<div class="distillery-body">' +
                              '<h3 class="pt-3 text-center">' + distillery.title + '</h3>' +
                              '<p>' + (distillery.summary ?? '') + '</p>' +
                              '</div>' +
                              '<div class="distillery-items">' +
                              innerHtml +
                              '</div>' +
                              '</div>';

                    const infoWindow = new google.maps.InfoWindow({
                        content: html
                    });

                    marker.addListener('click', () => {
                        if(activeWindow) {
                            activeWindow.close();
                        }
                        infoWindow.open(map, marker);
                        activeWindow = infoWindow;
                    });

                    google.maps.event.addListener(map, "click", function(event) {
                        infoWindow.close();
                    });

                    if(!isNaN(latLng.lat) && !isNaN(latLng.lng)) {
                        bounds.extend(latLng);
                    }
                }
            });

            // Set the new center, and bounds.
            map.fitBounds(bounds);
            map.setCenter(bounds.getCenter());
        }
    });
}


// BenedenBoven cookiescript
new CookieNotification();

if (document.querySelector('.filter-container')) {
    let containerEl = document.querySelector('.filter-container');
    let mixer = Mixitup(containerEl, {
        selectors: {
            target: '.filter-item',
            control: '.filter-input'
        },
        controls: {
            enable: false,
            toggleLogic: 'and'
        },
        animation: {
            duration: 300,
            easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)'
        },
        load: {
            filter: extractFiltersFromUrl()
        },
        callbacks: {
            onMixEnd: function(state) {
                let filterValues = [];
                document.querySelectorAll('.filter-items input:checked').forEach(element => {
                    filterValues.push(element.dataset.toggle.replace(/^\./, ''));
                });
                if (filterValues.length > 0) {
                    var queryString = '?filters=' + filterValues.join(',');
                    history.pushState(null, document.title, window.location.pathname + queryString);
                } else {
                    history.pushState(null, document.title, window.location.pathname);
                }

                document.querySelector('.collection-count').innerHTML = '(' + Array.from(document.querySelectorAll('.filter-item')).filter(s =>
                    window.getComputedStyle(s).getPropertyValue('display') !== 'none'
                ).length + '/' + document.querySelectorAll('.filter-item').length + ')';
            }
        }
    });

    window.addEventListener('popstate', function(event) {
        let filters = extractFiltersFromUrl();
        if (mixer.getState().activeFilter.selector === filters) return;
        mixer.filter(filters);
    });

    function extractFiltersFromUrl() {
        let filters = '.' + location.search.replace(/^\?filters=/, '').replace(/,/g, '.');

        if (filters === '.') {
            filters = '.filter-item';
        }

        document.querySelectorAll('.filter-input').forEach(filterItem => {
            filterItem.checked = false;
        });

        filters.split('.').forEach(filterItem => {
            if (filterItem !== '') {
                filterItem = '.' + filterItem;
                if (document.querySelector('.filter-input[data-toggle="' + filterItem + '"]')) {
                    document.querySelector('.filter-input[data-toggle="' + filterItem + '"]').checked = true;

                    if (document.querySelector('.filter-input[data-toggle="' + filterItem + '"]').parentNode.parentNode.parentNode) {
                        let element = document.querySelector('.filter-input[data-toggle="' + filterItem + '"]').parentNode.parentNode.parentNode;
                        if (element.classList.contains('collapse-child')) {
                            element.classList.add('show');
                            document.querySelector('[data-target="#' + element.id + '"]').checked = true;
                            document.querySelector('[data-target="#' + element.id + '"]').setAttribute('aria-expanded', 'true');

                            element = element.parentNode.parentNode;
                        }
                        if (document.querySelector('[aria-controls="' + element.id + '"]')) {
                            document.querySelector('[aria-controls="' + element.id + '"]').setAttribute('aria-expanded', 'true');
                            document.querySelector('[aria-controls="' + element.id + '"]').classList.remove('collapsed');
                            element.classList.add('show');
                        }
                    }
                }
            }

            setTimeout(function() {
                document.querySelector('.collection-count').innerHTML = '(' + Array.from(document.querySelectorAll('.filter-item')).filter(s =>
                    window.getComputedStyle(s).getPropertyValue('display') !== 'none'
                ).length + '/' + document.querySelectorAll('.filter-item').length + ')';
            }, 200);
        });

        return filters;
    }

    // Search filter
    //if(document.getElementById('filter-search')) {
    //    document.getElementById('filter-search').addEventListener('keyup', e => {
    //        e.preventDefault();
    //        updateFilter();
    //    });
    //}

    document.querySelectorAll('.filter-items input').forEach(element => {
        element.addEventListener('change', e => {
            e.preventDefault();
            updateFilter();
        });
    });

    function updateFilter() {
        //let searchQuery = document.getElementById('filter-search').value;
        let searchQuery = '';

        let ands = [];
        let ors = [];
        document.querySelectorAll('.filter-items input:checked').forEach(element => {
            if (element.dataset['action'] === 'or') {
                ors.push(element.dataset.toggle);
            } else if (element.dataset['action'] === 'and') {
                ands.push(element.dataset.toggle);
            }
        });

        if (ands.length > 0 && ors.length > 0) {
            for (let i in ands) {
                for (let u in ors) {
                    ors[u] = ands[i] + ors[u];
                }
            }
        }

        let filterString = '';
        if (ors.length === 0 && ands.length > 0) {
            filterString = ands.join('');
        } else {
            filterString = ors.join(', ');
        }

        filterString = filterString === '' ? 'all' : filterString;
        filterString = filterString === 'all' && searchQuery === '' ? 'all' : filterString;

        let elements = Array.from(document.querySelectorAll((filterString !== 'all' ? filterString : '.filter-item')));
        /*let filtered = elements.filter(target => {
            let regex = new RegExp(searchQuery.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$]/g, "\\$&"), 'gi');
            return target.getAttribute('data-search').match(regex);
        });*/

        mixer.filter(elements);
    }
}

// Smooth scroll
if (document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const href = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        });
    });
}

// Add and remove class on scroll
if (document.querySelector('nav')) {
    let scrollpos = window.scrollY
    var header = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', () => {
        scrollpos = window.scrollY;

        if (scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

// Modulobox
var modulobox = new ModuloBox({
    mediaSelector: '.gallery figure > a, .hidden-gallery div',
    loop: 3,
    history: true,
    controls: ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
    shareButtons: ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
    videoMaxWidth: 1440,
    minZoom: 1,
    zoomTo: 1.8,
    mouseWheel: false,
    contextMenu: false,
    scrollToZoom: true,
    captionSmallDevice: false,
    thumbnails: true,
    thumbnailsNav: 'centered',
    thumbnailSizes: {
        1920: {
            width: 110,
            height: 80,
            gutter: 10
        },
        1280: {
            width: 90,
            height: 65,
            gutter: 10
        },
        680: {
            width: 0,
            height: 0,
            gutter: 0
        }
    }
});

modulobox.on('beforeOpen.modulobox', (gallery, index) => {
    if (window.cubeRAF) {
        cancelAnimationFrame(window.cubeRAF);
        window.cubeRAF = false;
    }
});

modulobox.on('afterClose.modulobox', (gallery, index) => {
    if (typeof Event === 'function' && !window.cubeRAF) {
        window.dispatchEvent(new Event('scroll'));
    }
});

modulobox.init();

const initRecaptcha = () => {
    const recaptchaElement = document.getElementById('g-recaptcha');
    if (recaptchaElement) {
        grecaptcha.render('g-recaptcha', {
            'sitekey': recaptchaElement.dataset.sitekey
        });
    }
}

window.initRecaptcha = initRecaptcha;

// Init Flickity
if (document.querySelector('.main-carousel')) {
    let elem = document.querySelector('.main-carousel');
    let flkty = new Flickity(elem, {
        // options
        cellAlign: 'left',
        contain: true
    });
}